<template>
  <v-container class="mt-n6 service-container">
    <v-row class="pb-2 d-flex justify-center">
      <!-- <span class="main-icon"><font-awesome-icon :icon="['far', 'building']" /></span> «Новая Энергетика» -->
      <v-img :src="logo" max-height="120" max-width="90" class="mb-3 mt-n5 sub-item" />
    </v-row>
    <Banner></Banner>
    <v-row>
      <v-col v-for="(item, i) in menuItems" :key="i" cols="12">
        <v-card @click="$router.push(item.path)">
          <div class="d-flex flex-no-wrap justify-start">
            <v-avatar size="80" tile>
              <v-icon x-large v-html="item.icon" color="primary" />
            </v-avatar>
            <div>
              <v-card-title class="subtitle-2" v-text="item.title"></v-card-title>
              <v-card-subtitle>
                <a v-for="(srv, j) in service_items(item.services_name)" :key="j" class="card-item" @click.prevent="$router.push(item.path + srv.id)">{{ srv.name }}</a>
              </v-card-subtitle>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import routesOptions from '@/router/routes'
import logo from '@/assets/images/logo-ne_badge.png'

export default {
  name: 'Home',

  components: {
    Banner: () => import(
      /* webpackChunkName: "service" */
      '@/components/base/Banner'
    )
  },

  data: () => ({
    logo: logo
  }),

  computed: {
    menuItems: function() {
      return routesOptions
        .filter(item => item.meta.icon && item.path != '/' // show only those routes for which icons are specified(!item.meta.mode || (item.meta.mode || []).indexOf(checkingMode) > -1)
        )
        .map(item => ({
          path: item.path,
          title: item.meta.title,
          icon: item.meta.icon,
          services_name: item.meta.services_name
        }))
    },
    ...mapGetters({
      services: 'common/services',
      isLoggedIn: 'user/isAuthenticated',
      userRoles: 'user/userRoles'
    })
  },

  methods: {
    hasAccess: function(mode) {
      if (mode != 'common') {
        if (mode == 'private') return this.userRoles.includes('superuser')
        else return this.userRoles.includes(mode) || this.userRoles.includes('superuser')
      } else return true
    },
    service_items: function(name) {
      return this.services.filter(srv => srv.group == name && (srv['mode'] == 'common' || this.hasAccess(srv['mode'])))
    }
  }
}

</script>
<style scoped>
.card-item {
  text-decoration: none;
  color: black !important;
  opacity: 0.6;
}

.card-item:hover {
  color: #2196f3 !important;
  cursor: pointer;
  opacity: 1;
}

.card-item:after {
  content: " | ";
}

.card-item:hover:after {
  color: black;
  opacity: 0.6;
}

.card-item:last-child:after {
  content: '';
}

@media (min-width: 720px) {
  .sub-item {
    display: none;
  }
}

.icon-img {
  background-color: #26C6DA;
}

.centered-text {
  text-align: center;
  margin: 0 10px 0 10px;
}

.banner-img {
  height: 130px;
}

@media (max-width: 1000px) {
  .banner-img {
    height: 200px;
  }

  .service-container {
    padding: 0 !important;
  }
}

.service-container {
  padding-top: 0 !important;
}
</style>